import { action } from 'typesafe-actions';
import { Types, ITaggingParams } from './types';

export const sendTagging = (params: ITaggingParams) =>
  action(Types.SEND_TAGGING, params);

export const sendTaggingFailure = (error: unknown) =>
  action(Types.SEND_TAGGING_FAILURE, error);

export const sendTaggingSuccess = (taggingParams: ITaggingParams) =>
  action(Types.SEND_TAGGING_SUCCESS, taggingParams);
